import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import clearString from '~/prix/utils/bulk/clearString'
import { parseBooleanValue, parseStringArray } from '~/prix/utils/bulk/csvValueParsers'

const healthTeam: Dataset = {
  schema: 'public_health',
  table: 'health_team',
  columnTransformMap: {
    original_id: original => original,
    ine: original => original,
    health_unit_cnes: original => original,
    is_active: original => parseBooleanValue(original as string),
    name: original => clearString(original as string),
    health_team_type: original => clearString(original as string),
    health_team_linked: original => parseStringArray(original as string),
    data_source_id: original => (original != null ? Number(original) : null),
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default healthTeam
